import React from 'react';
import { motion } from 'framer-motion';
import { howItWorks } from '../data/mock';

const HowItWorksSection = () => {
  return (
    <section className="py-20 bg-section">
      <div className="container mx-auto px-4 md:px-8">
        {/* Section header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="heading-1 mb-4">Cómo funciona</h2>
          <p className="body-medium text-secondary max-w-2xl mx-auto">
            Un proceso sencillo para que tu perro reciba el mejor cuidado.
          </p>
        </motion.div>

        {/* Steps */}
        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Connecting line */}
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-accent-orange-200 via-accent-purple-200 to-accent-blue-200" />

            {howItWorks.map((step, index) => (
              <motion.div
                key={step.step}
                className={`relative flex flex-col md:flex-row items-center gap-6 md:gap-12 mb-12 last:mb-0 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
                initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                {/* Content */}
                <div className={`flex-1 text-center md:text-${index % 2 === 0 ? 'right' : 'left'}`}>
                  <span className="inline-block px-3 py-1 bg-primary text-white text-xs font-mono uppercase rounded-full mb-3">
                    Paso {step.step}
                  </span>
                  <h3 className="heading-3 mb-2">{step.title}</h3>
                  <p className="body-small text-secondary">{step.description}</p>
                </div>

                {/* Circle */}
                <div className="relative z-10 w-16 h-16 rounded-full bg-white shadow-lg flex items-center justify-center border-4 border-accent-orange-200">
                  <span className="text-2xl font-semibold text-primary">{step.step}</span>
                </div>

                {/* Spacer for alignment */}
                <div className="flex-1 hidden md:block" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
